
import React from 'react';
import classNames from 'classnames';
import { InputBaseProps } from '../../../interfaces/interfaces';
import MaskedInput from 'react-text-mask';

interface PhoneInputProps extends InputBaseProps {
	label?: string,
	invalid?: boolean,
	invalidMessage?: string,
	toastError?: boolean
}

const PhoneInput = ({ id, label, invalid, invalidMessage, className, placeholder, value, onBlur, onChange, toastError }: PhoneInputProps) => {

	const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {

		const newValue = event.currentTarget.value.replace(/\(|\)|_|-/g, '');
		onChange(newValue);

	};

	return (
		<div className="col px-0">
			<label htmlFor={id} className="mb-0">
				{label}
			</label>
			<div className="cc-input-group w-100">

				<MaskedInput
					id={id}
					inputMode='tel'
					type='tel'
					guide
					className={classNames(invalid && 'cc-input-field--invalid', className && className)}
					value={value}
					placeholder="(___) ___-____"
					mask={['(', /[2-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
					onChange={handleOnChange}
				/>
			</div>
			{invalid && invalidMessage && (
				<div className="invalid-error-message--input-field">{invalidMessage}</div>
			)}
		</div>
	);
};

export default PhoneInput;